(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wovyra-storefront-system"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('WovSaved');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const key = 'wovyra.saved-tees.v1';
  const strings = JSON.parse(dialog.querySelector('[data-wov-translations]').textContent);
  const list = dialog.querySelector('[data-wov-list]');
  const status = dialog.querySelector('[data-wov-status]');
  const announcement = document.querySelector('[data-wov-announcement]');
  const root = (window.Shopify?.routes?.root || dialog.dataset.root || '/').replace(/\/?$/, '/');
  let storageReady = true;
  let handles = [];
  let generation = 0;
  const valid = (value) => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value);
  const normalize = (values) => Array.isArray(values) ? [...new Set(values.filter(valid))].slice(0, 200) : [];
  try { handles = normalize(JSON.parse(localStorage.getItem(key) || '[]')); } catch { storageReady = false; }
  const announce = (message) => { if (announcement) announcement.textContent = message; };
  const persist = () => {
    if (storageReady) {
      try { localStorage.setItem(key, JSON.stringify(handles)); } catch { storageReady = false; }
    }
    dialog.querySelector('[data-wov-storage-error]').hidden = storageReady;
  };
  const sync = () => {
    document.querySelectorAll('[data-wov-save]').forEach((button) => {
      button.hidden = false;
      const saved = handles.includes(button.dataset.wovSave);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? button.dataset.removeLabel : button.dataset.saveLabel);
    });
    document.querySelectorAll('[data-wov-open]').forEach((button) => { button.hidden = false; });
    document.querySelectorAll('[data-wov-count]').forEach((count) => { count.textContent = handles.length ? String(handles.length) : ''; });
    dialog.querySelector('[data-wov-storage-error]').hidden = storageReady;
  };
  const money = (cents) => new Intl.NumberFormat(dialog.dataset.locale || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || dialog.dataset.currency || 'USD' }).format(cents / 100);
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const remove = (handle) => {
    handles = handles.filter((value) => value !== handle);
    persist(); sync(); announce(strings.removed);
    if (dialog.open) render();
  };
  const render = async () => {
    const current = ++generation;
    const focused = document.activeElement;
    const focusedRow = focused?.closest('.wov-saved__item');
    const focusState = dialog.open && focusedRow && list.contains(focusedRow) ? {
      handle: focusedRow.dataset.wovSavedHandle,
      index: [...list.children].indexOf(focusedRow),
      remove: Boolean(focused.closest('.wov-saved__remove')),
    } : null;
    list.replaceChildren();
    status.textContent = handles.length ? strings.loading : strings.empty;
    const snapshot = [...handles];
    const rows = snapshot.map((handle) => {
      const row = element('li', 'wov-saved__item');
      row.dataset.wovSavedHandle = handle;
      row.setAttribute('aria-busy', 'true');
      const slot = element('div');
      const body = element('div');
      body.append(element('h3', '', handle.replace(/-/g, ' ')));
      const link = element('a', '', strings.view);
      link.href = `${root}products/${encodeURIComponent(handle)}`;
      body.append(link);
      const removeButton = element('button', 'wov-saved__remove', strings.remove);
      removeButton.type = 'button';
      removeButton.addEventListener('click', () => remove(handle));
      body.append(removeButton);
      row.append(slot, body);
      list.append(row);
      return {handle, row, slot, body, link, removeButton};
    });
    if (focusState && dialog.open) {
      const matchingRow = rows.find(({handle}) => handle === focusState.handle);
      const focusRow = matchingRow || rows[Math.min(focusState.index, rows.length - 1)];
      const focusTarget = focusRow
        ? matchingRow && !focusState.remove ? focusRow.link : focusRow.removeButton
        : dialog.querySelector('[data-wov-close]');
      focusTarget?.focus({preventScroll: true});
    }
    let next = 0;
    const worker = async () => {
      while (next < rows.length && current === generation) {
        const {handle, row, slot, body, link} = rows[next++];
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {credentials:'same-origin', headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error(response.status === 404 ? 'unavailable' : 'loadError');
          const product = await response.json();
          if (current !== generation) return;
          body.querySelector('h3').textContent = product.title;
          if (product.featured_image) {
            const imageUrl = new URL(product.featured_image, window.location.origin);
            if (imageUrl.protocol === 'https:' || imageUrl.origin === window.location.origin) {
              imageUrl.searchParams.set('width', '180');
              const image = element('img');
              image.src = imageUrl.href; image.alt = product.title; image.width = 90; image.height = 90; image.loading = 'lazy';
              slot.append(image);
            }
          }
          const amount = money(product.price);
          const priceText = product.price_varies ? strings.from.replace('__PRICE__', amount) : amount;
          body.insertBefore(element('p', '', product.available ? priceText : `${priceText} · ${strings.soldOut}`), link);
        } catch (error) {
          if (current !== generation) return;
          body.insertBefore(element('p', '', strings[error.message] || strings.loadError), link);
        } finally {
          row.setAttribute('aria-busy','false');
        }
      }
    };
    await Promise.all(Array.from({length:Math.min(4, rows.length)}, worker));
    if (current === generation) status.textContent = snapshot.length ? '' : strings.empty;
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wov-save]');
    if (button) {
      event.preventDefault();
      const handle = button.dataset.wovSave;
      if (!valid(handle)) return;
      if (handles.includes(handle)) { remove(handle); return; }
      if (handles.length >= 200) { announce(strings.limit); return; }
      handles.push(handle); persist(); sync(); announce(strings.added);
      return;
    }
    if (event.target.closest('[data-wov-open]')) {
      dialog.showModal(); render();
    }
    if (event.target.closest('[data-wov-close]')) dialog.close();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { generation++; });
  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button, a[href], input, select, textarea, [tabindex]')].filter((element) => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
    if (!controls.length) { event.preventDefault(); return; }
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  });
  window.addEventListener('storage', (event) => {
    if (event.key !== key && event.key !== null) return;
    try { handles = normalize(JSON.parse(event.newValue || '[]')); sync(); if (dialog.open) render(); } catch {}
  });
  new MutationObserver((records) => {
    if (records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches('[data-wov-save], [data-wov-open]') || node.querySelector('[data-wov-save], [data-wov-open]'))))) sync();
  }).observe(document.body, {childList:true, subtree:true});
  sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wovyra-tee-search-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-wov-tee-query]').forEach((form) => {
    const input = form.querySelector('[data-wov-keywords]');
    input.disabled = false;
    form.querySelector('button').disabled = false;
    form.addEventListener('submit', () => {
      const words = input.value.trim().split(/\s+/).map((word) => word.replace(/["\\]/g, '')).filter(Boolean);
      form.querySelector('[name="q"]').value = [form.dataset.scope, ...words.map((word) => `"${word}"`)].join(' ');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
